import { render } from "./PortionList.vue?vue&type=template&id=f6d113a2"
import script from "./PortionList.vue?vue&type=script&lang=js"
export * from "./PortionList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__